import request from '@/utils/request'

export async function getUser(data) {
  return request({
    url: '/user/page',
    method: 'post',
    data,
  })
}
export async function findUser(data) {
  return request({
    url: '/user/get',
    method: 'post',
    data,
  })
}
export async function createUser(data) {
  return request({
    url: '/user/save',
    method: 'post',
    data,
  })
}
export async function updateUser(data) {
  return request({
    url: '/user/update',
    method: 'post',
    data,
  })
}
export async function updateUserSelf(data) {
  return request({
    url: '/user/updateSelf',
    method: 'post',
    data,
  })
}
export async function updatePswSelf(data) {
  return request({
    url: '/user/password/updateSelf',
    method: 'post',
    data,
  })
}
export async function deleteUser(data) {
  return request({
    url: '/user/delete',
    method: 'post',
    data,
  })
}

//用户绑定角色
export function userBindRole(data) {
  return request({
    url: '/user/role/bind',
    method: 'post',
    data,
  })
}

//获取用户的角色
export function getUserRole(data) {
  return request({
    url: '/role/findByUserId',
    method: 'post',
    data,
  })
}
